import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-logo">
        <img src="/logo.png" alt="Logo" className="logo-image" />
      </div>

      <div
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      <nav className={`header-nav ${menuOpen ? "open" : ""}`}>
        {/* ⭐ CLOSE BUTTON */}
        <button className="close-menu" onClick={() => setMenuOpen(false)}>
          ×
        </button>

        <ul>
          <li>
            <Link to="/home" onClick={() => setMenuOpen(false)}>Home</Link>
          </li>
       
          <li>
            <Link to="/badgelist" onClick={() => setMenuOpen(false)}>Badges</Link>
          </li>
          <li>
            <Link to="/avatar" onClick={() => setMenuOpen(false)}>Avatars</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
